/*
 * Copyright (c) 2022. American Express Company
 */

// 3rd party
import { ChronoUnit, LocalDate } from '@js-joda/core';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import { PersonCardViewModel } from 'src/types/view-models/person-card.view.model';

// components
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// stylesheets
import styles from './ProfilePersonCard.module.scss';
import { GlyphRight } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import PersonIcon from 'src/components/person-icon/PersonIcon';

export default class ProfilePersonCard extends Component<PersonCardViewModel> {
    public override render(): ReactComponentElement<any> {
        if (this.props.person) {
            let age: string = 'unknown';

            try {
                if (this.props.person.dob) {
                    let ageNum = this.props.person.dob.until(LocalDate.now(), ChronoUnit.YEARS);
                    if (ageNum === 0) {
                        // for children under 1, code used to show unknown, now show agen in months or newborn
                        ageNum = this.props.person.dob.until(LocalDate.now(), ChronoUnit.MONTHS);
                        age = ageNum ? `${ageNum} month${ageNum === 1 ? '' : 's'}` : 'newborn';
                    } else {
                        age = ageNum.toString();
                    }
                }
            } catch (e) {}

            return (
                <div className={this.getClasses()} key={this.props.person.personUid}>
                    <div className={styles.personCardTopRow}>
                        <div className={styles.topLeftColumn}>
                            <Typography variant={TypographyVariants.HEADING_XS} className={styles.personName}>
                                {this.props.person.nickname}
                            </Typography>
                            <Typography variant={TypographyVariants.SUBTEXT}>Age: {age}</Typography>
                            <Typography variant={TypographyVariants.CAPTION} className={styles.personRelationship}>
                                {this.props.person.relationship === 'self'
                                    ? LiteralsService.getLiteral('ProfilePersonCard.planOwner')
                                    : this.props.person.relationship}
                            </Typography>
                        </div>
                        <PersonIcon person={this.props.person} />
                    </div>
                    {this.props.person.relationship !== 'self' && (
                        <>
                            <div className={styles.personDivider}>
                                <hr />
                            </div>
                            <button
                                className={styles.personCardBottomRow}
                                onClick={() => this.props.onClick(this.props.person)}
                            >
                                <Typography variant={TypographyVariants.SUBTEXT_BOLD} className={styles.editProfile}>
                                    {this.props.personText ||
                                        LiteralsService.getLiteral('ProfilePersonCard.editProfile')}
                                </Typography>
                                <GlyphRight className={styles.editProfileGlyph} />
                            </button>
                        </>
                    )}
                </div>
            );
        }
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(this.props.person.relationship);

        if (this.props.index) {
            classes.push(`person-${this.props.index}`);
        }

        classes.push(styles.personCard);

        return classes.join(' ');
    }
}
